export default __webpack_public_path__ + "static/media/clock.126b4a66.svg";